import sleep from 'lib/sleep'

//
// Poll until a condition holds or a deadline passes. Third-party SDKs we load
// via a <script> tag (AWS WAF, PostHog, Chili Piper) all initialise
// asynchronously and give us no promise to await, so the only way to know
// they're ready is to look. This existed three times over before it was
// extracted — see client/lib/aws-waf.ts and client/lib/posthog.ts.
//
// Resolves true as soon as `isReady()` returns true, false once `timeoutMs`
// has elapsed. Never rejects: `sleep` can't fail and the predicate is called
// inside the loop, so callers only ever branch on the boolean.
//
export const waitForGlobal = async (
  isReady: () => boolean,
  { intervalMs, timeoutMs }: { intervalMs: number; timeoutMs: number }
): Promise<boolean> => {
  const deadline = Date.now() + timeoutMs

  while (!isReady()) {
    if (Date.now() >= deadline) {
      return false
    }
    await sleep(intervalMs)
  }

  return true
}

export default waitForGlobal
